<template>

	<v-card class="mb-4">
		<v-card-text class="py-2">
			<div class="d-flex align-center justify-space-between">
				<div class="d-flex align-center">
					<p class="font-weight-bold body-2 px-1 mb-0 mr-2">Datos Generales</p>
				</div>
			</div>
			<v-divider class="my-2"></v-divider>
			<div class="px-0 py-0">
				<!-- <div class="d-flex justify-space-between align-center mb-1 px-1 item-background-hover">
					<div class="d-flex justify-space-between" style="width: 100%"><div style="width: 190px">CRM/Solicitud</div><span>:</span> <b class="text-end" style="flex: 1;">{{preproject.info?.crm_id}}</b></div>
					<div class="action-container"></div>
				</div> -->
				<div class="d-flex justify-space-between align-center mb-1 px-1 item-background-hover">
					<div class="d-flex justify-space-between" style="width: 100%"><div style="width: 190px">CRM / Solicitud / VT</div><span>:</span> <b class="text-end" style="flex: 1;">{{preproject.project_line_info?.id}}</b></div>
					<div class="action-container">
						<v-btn
							icon
							color="warning"
							x-small
							v-if="preproject.info"
							@click="toCRM(associatedCrm?.morphable_id)"
						>
							<v-icon>mdi-eye</v-icon>
						</v-btn>
					</div>
				</div>
				<div class="d-flex justify-space-between mb-1 px-1 item-background-hover">
					<div style="width: 190px">Fecha de creación</div><span>:</span> <b class="text-end" style="flex: 1;">{{preproject.created_at | toDateTime}} hrs.</b>
					<div class="action-container"></div>
				</div>
				<div class="d-flex justify-space-between align-center mb-1 px-1 item-background-hover" v-if="editProjectDetail">
					<v-text-field
						v-model="newProjectDetail"
						label="Proyecto"
						placeholder="Nombre proyecto"
						outlined
						required
						dense
						hide-details=""
						maxlength="255"
						class="my-1"
					>
						<template v-slot:append-outer>
							<v-btn
								icon
								color="error"
								@click="editProjectDetail = false"
								:disabled="!canEditInfo"
							>
								<v-icon>mdi-close</v-icon>
							</v-btn>
							<v-btn
								icon
								color="warning"
								@click="sendEditProjectDetail"
								:disabled="!canEditInfo"
							>
								<v-icon>mdi-check</v-icon>
							</v-btn>
						</template>
					</v-text-field>
				</div>
				<div class="d-flex justify-space-between align-center mb-1 px-1 item-background-hover" v-else>
					<div style="width: 190px">Proyecto</div><span>:</span> <b class="text-end" style="flex: 1;">{{preproject?.name}}</b>
					<div class="action-container">
						<v-btn
							icon
							color="warning"
							x-small
							@click="startEditProjectDetail"
							:disabled="!canEditInfo"
						>
							<v-icon>mdi-pencil-outline</v-icon>
						</v-btn>
					</div>
				</div>
				<div class="d-flex justify-space-between align-center mb-1 px-1 item-background-hover" v-if="editProjectAddress">
					<v-autocomplete
						v-model="newProjectAddress"
						:items="[...itemsAddress, ...[preproject.info?.address?.address]]"
						name="address"
						:search-input.sync="search"
						prepend-inner-icon="mdi-map-marker"
						label="Dirección"
						placeholder="Dirección"
						autocomplete="off"
						outlined
						dense
						hide-details
						:loading="loadingAddress"
						:filter="d => d"
						color="secondary"
						item-color="secondary"
						return-object
						@change="change"
					></v-autocomplete>
					<v-btn
						class="mx-1"
						icon
						color="error"
						@click="editProjectAddress = false"
						:disabled="!canEditInfo"
					>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</div>
				<div class="d-flex justify-space-between align-center mb-1 px-1 item-background-hover" v-else>
					<div style="width: 190px">Dirección Proyecto</div><span>:</span> <b class="text-end" style="flex: 1;">{{preproject.info?.address?.address}}</b>
					<div class="action-container">
						<v-btn
							icon
							color="warning"
							x-small
							@click="startEditProjectAddress"
							:disabled="!canEditInfo"
						>
							<v-icon>mdi-pencil-outline</v-icon>
						</v-btn>
					</div>
				</div>
				<div class="d-flex justify-space-between align-center mb-1 px-1 item-background-hover" v-if="editProjectRol">
					<v-text-field
						v-model="newProjectRol"
						label="Rol"
						placeholder="Rol proyecto"
						outlined
						required
						dense
						hide-details=""
						maxlength="255"
						class="my-1"
					>
						<template v-slot:append-outer>
							<v-btn
								icon
								color="error"
								@click="editProjectRol = false"
								:disabled="!canEditInfo"
							>
								<v-icon>mdi-close</v-icon>
							</v-btn>
							<v-btn
								icon
								color="warning"
								@click="sendEditProjectRol"
								:disabled="!canEditInfo"
							>
								<v-icon>mdi-check</v-icon>
							</v-btn>
						</template>
					</v-text-field>
				</div>
				<div class="d-flex justify-space-between align-center mb-1 px-1 item-background-hover" v-else>
					<div style="width: 190px">Rol Proyecto</div><span>:</span> <b class="text-end" style="flex: 1;">{{preproject.info?.address?.rol}}</b>
					<div class="action-container">
						<v-btn
							icon
							color="warning"
							x-small
							@click="startEditProjectRol"
							:disabled="!canEditInfo"
						>
							<v-icon>mdi-pencil-outline</v-icon>
						</v-btn>
					</div>
				</div>
				<div class="d-flex justify-space-between align-center mb-1 px-1 item-background-hover">
					<div style="width: 190px">Municipio</div><span>:</span> <b class="text-end" style="flex: 1;">{{preproject.info?.address?.district?.name}}</b>
					<v-menu v-model="cityMenu" offset-y z-index="9999" :close-on-content-click="false" content-class="menu-bg-white" style="z-index: 9999; background-color: white;">
						<template v-slot:activator="{ on, attrs }">
							<div class="action-container">
								<v-btn
									icon
									color="warning"
									x-small
									:disabled="!canEditInfo"
									v-bind="attrs"
									v-on="on"
								>
									<v-icon dark small>mdi-swap-horizontal-bold</v-icon>
								</v-btn>
							</div>
						</template>
						<v-list dense class="py-0" max-height="200" style="z-index: 9999;background-color: white;">
							<v-list-item dense class="mb-1" style="min-height: 25px; background: #959595;">
								<p class="caption mb-0 font-weight-bold white--text">Cambiar Municipalidad</p>
							</v-list-item>
							<v-list-item dense class="mb-1 px-1" style="min-height: 25px;">
								<v-text-field
									v-model="searchCity"
									label="Filtro"
									placeholder="Búsqueda"
									outlined
									required
									dense
									hide-details
									class="custom-height-search custom-height-calendar"
									style="max-width: 160px;"
								></v-text-field>
							</v-list-item>
							<v-list-item-group color="#524D4D">
								<v-list-item
									v-for="(city, index) in cities"
									:key="index"
									dense
									@click="changePreProjectCity(city.id)"
								>
									<v-list-item-title dense>
										{{ city.name }}
									</v-list-item-title>
								</v-list-item>
							</v-list-item-group>
						</v-list>
					</v-menu>
				</div>
				<div class="d-flex justify-space-between align-center mb-1 px-1 item-background-hover">
					<div style="width: 190px">Tipo de Proyecto</div><span>:</span> <b class="text-end" style="flex: 1;">{{preproject.info?.project_type?.name}}</b>
					<div class="action-container">
						<ProjectTypeSelectorMenu
							:isDisabled="!canEditInfo"
							:onClick="(project_type) => { changeProjectType(project_type.id) }"/>
					</div>
				</div>
				<div class="d-flex justify-space-between align-center mb-1 px-1 item-background-hover">
					<div style="width: 190px">Zona Proyecto</div><span>:</span> <b class="text-end" style="flex: 1;">{{preproject.info?.zone?.name}}</b>
					<v-menu v-model="zoneMenu" offset-y z-index="9999" :close-on-content-click="false" content-class="menu-bg-white" style="z-index: 9999; background-color: white;">
						<template v-slot:activator="{ on, attrs }">
							<div class="action-container">
								<v-btn
									icon
									color="warning"
									x-small
									:disabled="!canEditInfo"
									v-bind="attrs"
									v-on="on"
								>
									<v-icon dark small>mdi-swap-horizontal-bold</v-icon>
								</v-btn>
							</div>
						</template>
						<v-list dense class="py-0" max-height="200" style="z-index: 9999;background-color: white;">
							<v-list-item dense class="mb-1" style="min-height: 25px; background: #959595;">
								<p class="caption mb-0 font-weight-bold white--text">Cambiar Zona Proyecto</p>
							</v-list-item>
							<v-list-item-group color="#524D4D">
								<v-list-item
									v-for="(zone, index) in zones"
									:key="index"
									dense
									@click="changePreProjectZone(zone.id)"
								>
									<v-list-item-title dense>
										{{ zone.name }}
									</v-list-item-title>
								</v-list-item>
							</v-list-item-group>
						</v-list>
					</v-menu>
				</div>
				<div class="d-flex justify-space-between align-center mb-1 px-1 item-background-hover">
					<div style="width: 190px">Usuario Responsable</div><span>:</span> <b class="text-end" style="flex: 1;">{{preproject.responsible?.profile?.name}} {{preproject.responsible?.profile?.lastname}} {{preproject.responsible?.profile?.second_lastname}}</b>
					<v-menu offset-y z-index="9999" content-class="menu-bg-white" style="z-index: 9999; background-color: white;">
						<template v-slot:activator="{ on, attrs }">
							<div class="action-container">
								<v-btn
									icon
									color="warning"
									x-small
									:disabled="!editPermission"
									v-bind="attrs"
									v-on="on"
								>
									<v-icon dark small>mdi-swap-horizontal-bold</v-icon>
								</v-btn>
							</div>
						</template>
						<v-list dense class="py-0" max-height="200" style="z-index: 9999;background-color: white;">
							<v-list-item dense class="mb-1" style="min-height: 25px; background: #959595;">
								<p class="caption mb-0 font-weight-bold white--text">Cambiar Responsable</p>
							</v-list-item>
							<v-list-item-group color="#524D4D">
								<v-list-item
									v-for="(responsible, index) in $store.state.users.usersList"
									:key="index"
									dense
									@click="changePreProjectResponsible(responsible.id)"
								>
									<v-list-item-title dense>
										<div class="d-flex align-center">
											<img :src="responsible.profile.avatar" class="user-avatar mr-2" v-if="responsible?.profile?.avatar"/>
											<v-icon v-else class="user-avatar icon mr-2" color="#524D4D">mdi-account</v-icon>
											<div>
												<p class="mb-0">{{ responsible.profile?.name }} {{ responsible.profile?.lastname }} {{ responsible.profile?.second_lastname }}</p>
												<p class="mb-0 caption">{{ responsible.email }}</p>
											</div>
										</div>
									</v-list-item-title>
								</v-list-item>
							</v-list-item-group>
						</v-list>
					</v-menu>
				</div>
				<div class="d-flex justify-space-between align-center mb-1 px-1 item-background-hover" v-if="editProjectDescription">
					<v-text-field
						v-model="newProjectDescription"
						label="Observación / Descripción"
						placeholder="Observación / Descripción proyecto"
						outlined
						required
						dense
						hide-details=""
						maxlength="255"
						class="my-1"
					>
						<template v-slot:append-outer>
							<v-btn
								icon
								color="error"
								@click="startEditDescription"
								:disabled="!canEditInfo"
							>
								<v-icon>mdi-close</v-icon>
							</v-btn>
							<v-btn
								icon
								color="warning"
								@click="sendEditProjectDescription"
								:disabled="!canEditInfo"
							>
								<v-icon>mdi-check</v-icon>
							</v-btn>
						</template>
					</v-text-field>
				</div>
				<div class="d-flex justify-space-between align-center mb-1 px-1 item-background-hover" v-else>
					<div style="width: 190px">Observación / Descripción</div><span>:</span> <b class="text-end" style="flex: 1;">{{preproject.description}}</b>
					<div class="action-container">
						<v-btn
							icon
							color="warning"
							x-small
							@click="startEditDescription"
							:disabled="!canEditInfo"
						>
							<v-icon>mdi-pencil-outline</v-icon>
						</v-btn>
					</div>
				</div>
			</div>
		</v-card-text>
	</v-card>
</template>

<script>
import { gmapApi } from 'vue2-google-maps'
import {updatePreProjectInfo, setResponsible} from '@/helpers/api/preprojects'
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'
import ProjectTypeSelectorMenu from '@/components/Helpers/Components/ProjectTypeSelectorMenu'

export default {
	name: 'PreProjectModule',
	components: { ProjectTypeSelectorMenu },
	props: {
		openCrmDetail: {
      type: Function
    },
		isVertical:{
			type: Boolean,
			default: false
		}
	},
  data() {
    return {
			openChat: false,
			openBudget: false,
			searchCity: '',
			cityMenu: false,
			zoneMenu: false,
			selectedFile: null,
			loadingChatCreation: false,
			add_chat_users_id: [],
			showNewBudgetPart: false,
			newBudgetPart: {
				value: null,
				concept: null,
				preproject_id: null
			},
			filesToUpload: [],
			loadingRemoveFile: false,
			mapZoom: 7,
      zoomInterval: null,
      isZooming: false,
			itemsAddress: [],
			loadingAddress: false,
			search: '',
			autocompleteService: null,
			tab: null,
			items: ['Información', 'Conversación', 'Correos Enviados', 'Informes'],
			reportTemplate: null,
			loading: false,
			editValue: false,
			editProjectDetail: false,
			editScheduleTitle: false,
			editUser: false,
			editAddress: false,
			editProjectAddress: false,
			newProjectAddress: null,
			editProjectRol: false,
			newProjectRol: null,
			newValueCrm: null,
			newScheduleTitle: null,
			newProjectDetail: null,
			loadingEditUser: false,
			editProjectDescription: false,
			newProjectDescription: null,
			reportEditor: '',
			menuTemplates: false,
			cc_report: null,
			scheduledUserId: null,
			changingScheduleUser: false,
			subject: 'Informe Visita Técnica',
			report_title: 'Informe Visita Técnica Revisión Normativa',
			activePanel: 2,
			templateName: null,
			userData: {
				name: null,
				email: null,
				phone: null
			},
			cachingItems: false,
			newAddress: {address: null, coordinates: null},
			requiredRule: [
				v => !!v || 'Campo requerido'
			],
			phoneRule: [
				v => !!v || 'Campo requerido',
				v => /^569\d{8}$/.test(v) || 'Debe tener 11 dígitos y empezar con 569',
			],
    };
  },
  computed: {
		google: gmapApi,
		canEditInfo(){
			// Puede editar sólo si tiene permiso y si no hay un contrato firmado en la línea de proyectos
			return this.editPermission && !this.preproject?.pl_signed_contract
		},
		cities(){
			return this.$store.state.general.countryCities.filter(city => city.name.toLowerCase().includes(this.searchCity.toLowerCase()))
		},
		zones(){
			return this.$store.state.projects.zoneIpt
		},
		editPermission(){
			return this.$checkPermissions(['edit_crm']) || this.scheduledUserId == this.$store.state.user.userInfo.id
		},
		loadingUsers(){
			return this.$store.state.users.loadingUserList || this.changingScheduleUser
		},
    preproject() {
      return this.$store.state.preprojects.preProject
    },
		associatedCrm(){
			return this.preproject.associations?.associations?.find((el) => {
				return el.morphable_type == 'App\\Models\\BotConversation'
			})
		}
  },
	watch: {
    search(newSearch) {
			this.cachingItems = false
      if (newSearch) {
        this.googleSearch(newSearch);
      } else {
        this.itemsAddress = []
      }
    }
	},
	mounted(){
		try {
			this.$store.dispatch('projects/getAllZoneIpts')
			this.$nextTick(() => {
				this.$gmapApiPromiseLazy().then(() => {
					this.autocompleteService = new this.google.maps.places.AutocompleteService()
				})
			});
		} catch (error) {
			console.log('Error: ', error)
		}
	},
  methods: {
		checkUpdateClient(){
			if(this.$route.name == 'Client' && this.$route.params?.id){
				const client_id = this.$route.params?.id
				this.$store.dispatch('preprojects/getClientPreProjects', {
					client_id,
					start: 1,
					limit: 100
				})
			}
		},
		startEditProjectDetail(){
			this.editProjectDetail = !this.editProjectDetail
			this.newProjectDetail = this.preproject?.name
		},
		startEditProjectAddress(){
			this.editProjectAddress = !this.editProjectAddress
			this.newProjectAddress = this.preproject.info?.address?.address
		},
		startEditProjectRol(){
			this.editProjectRol = !this.editProjectRol
			this.newProjectRol = this.preproject.info?.address?.rol
		},
		startEditTitle(){
			this.editScheduleTitle = !this.editScheduleTitle
			this.newScheduleTitle = this.conversation.schedule.user_schedule?.title
		},
		isNumberKey(event) {
			const charCode = event.which ? event.which : event.keyCode;
			if (charCode < 48 || charCode > 57) {
				event.preventDefault();
			}
		},
    googleSearch(query) {
      const options = {
        input: query,
				componentRestrictions: { country: 'CL' }
      };
      this.autocompleteService.getPlacePredictions(options, (predictions, status) => {
        if (status === this.google.maps.places.PlacesServiceStatus.OK) {
          this.itemsAddress = predictions.map(prediction => ({
            text: prediction.description,
            value: prediction 
          }));
        } else {
          console.error('Error fetching predictions: ', status);
          this.itemsAddress = [];
        }
      });
    },
		async getPlaceDetails(placeId) {
			if (typeof this.google !== 'undefined' && this.google.maps) {
				const service = new this.google.maps.places.PlacesService(document.createElement('div'));
				
				service.getDetails({ placeId }, (place, status) => {
					if (status === this.google.maps.places.PlacesServiceStatus.OK) {
						const { geometry } = place;
						this.newAddress.coordinates = {
							lat: geometry.location.lat(),
							lng: geometry.location.lng()
						}
						this.updateAddress(this.newAddress)
					}
				});
			} else {
				console.error('Google Maps API no está cargada');
			}
		},
		async sendEditProjectRol(){
			const data = {
				preproject_id: this.preproject.id,
				rol: this.newProjectRol
			}
			await updatePreProjectInfo(data)
			this.$store.dispatch('preprojects/getPreProject', {preproject_id: this.preproject.id})
			this.editProjectRol = false
			this.newProjectRol = null
		},
		startEditDescription(){
			this.editProjectDescription = !this.editProjectDescription
			this.newProjectDescription = this.preproject.description
		},
		async sendEditProjectDescription(){
			const data = {
				preproject_id: this.preproject.id,
				description: this.newProjectDescription
			}
			await updatePreProjectInfo(data)
			this.checkUpdateClient()
			this.$store.dispatch('preprojects/getPreProject', {preproject_id: this.preproject.id})
			this.editProjectDescription = false
			this.newProjectDescription = this.preproject.description
		},
		async sendEditProjectDetail(){
			const data = {
				preproject_id: this.preproject.id,
				name: this.newProjectDetail
			}
			await updatePreProjectInfo(data)
			this.checkUpdateClient()
			this.$store.dispatch('preprojects/getPreProject', {preproject_id: this.preproject.id})
			this.editProjectDetail = false
			this.newProjectDetail = this.preproject?.name
			this.reloadParentsEvent()
		},
		async changeProjectType(project_type_id){
			const data = {
				preproject_id: this.preproject.id,
				project_type_id
			}
			await updatePreProjectInfo(data)
			this.checkUpdateClient()
			this.$store.dispatch('preprojects/getPreProject', {preproject_id: this.preproject.id})
			this.reloadParentsEvent()
		},
		async changePreProjectCity(district_id){
			const data = {
				preproject_id: this.preproject.id,
				district_id
			}
			this.cityMenu = false
			await updatePreProjectInfo(data)
			this.checkUpdateClient()
			this.$store.dispatch('preprojects/getPreProject', {preproject_id: this.preproject.id})
			this.editProjectRol = false
			this.newProjectRol = null
		},
		async changePreProjectZone(zone_id){
			const data = {
				preproject_id: this.preproject.id,
				zone_id
			}
			this.zoneMenu = false
			await updatePreProjectInfo(data)
			this.checkUpdateClient()
			this.$store.dispatch('preprojects/getPreProject', {preproject_id: this.preproject.id})
			this.editProjectRol = false
			this.newProjectRol = null
		},
		async changePreProjectResponsible(responsible_id){
			const data = {
				preproject_id: this.preproject.id,
				responsible_id
			}
			await setResponsible(data)
			this.$store.dispatch('preprojects/getPreProject', {preproject_id: this.preproject.id})
		},
		async updateAddress(address){
			const data = {
				...{preproject_id: this.preproject.id},
				...address
			}
			this.loadingAddress = true
			await updatePreProjectInfo(data)
			this.checkUpdateClient()
			this.$store.dispatch('preprojects/getPreProject', {preproject_id: this.preproject.id})
			this.loadingAddress = false
			this.editProjectAddress = false
			this.newProjectAddress = null
			this.reloadParentsEvent()
		},
    change(value) {
			this.getPlaceDetails(value.value.place_id)
      this.newAddress.address = value.text
    },
		reloadParentsEvent(){
			eventBus.$emit('reloadInformation', {})
		},
		toCRM(crm_id) {
			console.log('toCRM', crm_id)
			this.$store.commit('crm/setCrmModalId', crm_id)
			// if(this.openCrmDetail){
			// 	this.openCrmDetail(crm_id)
			// }
			// else{
			// 	// this.$router.push({ name: 'Conversation', params: { id: crm_id } })
			// 	this.$store.commit('crm/setCrmModalId', crm_id)
			// }
		}
  },
};
</script>

<style scoped>
	.messages-container{
		display: flex;
		flex-direction: column;
		padding: 10px;
		flex: 1;
		border-radius: 10px;
		height: 400px;
		overflow-y: scroll;
	}
	.single-message{
		background-color: rgb(217, 239, 217);
		border: 1px solid rgb(197, 232, 197);
		padding: 4px 8px;
		max-width: 80%;
		border-radius: 10px;
		font-size: 14px;
		margin-bottom: 8px;
		text-transform: none;
	}
	.single-message.assistant{
		background-color: rgb(213, 211, 211);
		border: 1px solid rgb(193, 191, 191);
		align-self: flex-end;
	}
	.template-list-item:hover{
		background-color: rgba(0,0,0,0.2);
	}
	.menu-bg-white{background: white;}
	.single-file-container{
		background-color: white;
		border: 1px solid rgb(193, 191, 191);
	}
	.file-icon-buttons{
		width: 70px;
		height: 80px;
		border: 1px solid rgb(213, 211, 211);
		cursor: pointer;
	}
	.file-icon-buttons:hover{
		background-color: rgb(239, 239, 239);
	}
	.file-icon-buttons.selected{
		background-color: rgb(213, 211, 211);
	}
	.truncate-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
	}
	.image-viewer{
		background-image: url('data:image/gif;base64,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');
		background-position: center;
		background-repeat: no-repeat;
	}
	.item-background-hover:hover{
		background-color: rgba(0,0,0,0.1);
	}
	.action-container{
		width: 30px;
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}
</style>
<style>
	.crm-conversation .single-message p{
		margin-bottom: 0;
	}
</style>